import $ from 'jquery';
//window.$ = window.jQuery = $;
import "popper.js";
require('bootstrap');
require('slick-carousel');

import './scripts/nav';
import './scripts/search';
import './scripts/frontPage';
import './scripts/filter';
import './scripts/footer';
import './scripts/sliders';
import './scripts/slider-news';
import './scripts/load-more';
import './scripts/download';
import './scripts/contact';